import {
  ChartType,
  PitcherReportChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitcherSingleSessionReportChartConfigDto,
  GraphChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig = PitcherReportChartConfigDto | PitcherSessionReportChartConfigDto | PitcherSingleSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<GraphChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  chartKey: keyof TReportConfig;
};

const PlayerScatterChartSidebar = <T extends ReportConfig>({ extraChartData, setTempLayout, tempLayout, chartId, chartKey }: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('X Axis:')}
        options={extraChartData.availableStats}
        selected={extraChartData.xAxis}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              xAxis: selected,
            },
          })
        }
        disabled={false}
      />
      <GenericRadioConfig
        label={t('Y Axis:')}
        options={extraChartData.availableStats}
        selected={extraChartData.yAxis}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              yAxis: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

const PitcherScatterChartSidebar_1 = (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherScatterChart_1' chartKey='pitcherScatterChartConfig_1' {...props} />;
};

const PitcherScatterChartSidebar_2 = (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherScatterChart_2' chartKey='pitcherScatterChartConfig_2' {...props} />;
};

const PitcherScatterChartSidebar_3 = (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherScatterChart_3' chartKey='pitcherScatterChartConfig_3' {...props} />;
};

const PitcherSessionScatterChartSidebar_1 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherSessionScatterChart_1' chartKey='pitcherSessionScatterChartConfig_1' {...props} />;
};

const PitcherSessionScatterChartSidebar_2 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherSessionScatterChart_2' chartKey='pitcherSessionScatterChartConfig_2' {...props} />;
};

const PitcherSessionScatterChartSidebar_3 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerScatterChartSidebar chartId='PitcherSessionScatterChart_3' chartKey='pitcherSessionScatterChartConfig_3' {...props} />;
};

const PitcherSingleSessionScatterChartSidebar_1 = (
  props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <PlayerScatterChartSidebar
      chartId='PitcherSingleSessionScatterChart_1'
      chartKey='pitcherSingleSessionScatterChartConfig_1'
      {...props}
    />
  );
};

const PitcherSingleSessionScatterChartSidebar_2 = (
  props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <PlayerScatterChartSidebar
      chartId='PitcherSingleSessionScatterChart_2'
      chartKey='pitcherSingleSessionScatterChartConfig_2'
      {...props}
    />
  );
};

const PitcherSingleSessionScatterChartSidebar_3 = (
  props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <PlayerScatterChartSidebar
      chartId='PitcherSingleSessionScatterChart_3'
      chartKey='pitcherSingleSessionScatterChartConfig_3'
      {...props}
    />
  );
};

export {
  PitcherScatterChartSidebar_1,
  PitcherScatterChartSidebar_2,
  PitcherScatterChartSidebar_3,
  PitcherSessionScatterChartSidebar_1,
  PitcherSessionScatterChartSidebar_2,
  PitcherSessionScatterChartSidebar_3,
  PitcherSingleSessionScatterChartSidebar_1,
  PitcherSingleSessionScatterChartSidebar_2,
  PitcherSingleSessionScatterChartSidebar_3,
};
